<template>
  <div class="box">
    <div class="top">
      <div class="title">交易须知</div>
      <div @click="toHighEndTradeRule({fundCode, fundName})" class="top-right">
        <div class="more">更多</div>
        <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png"/>
      </div>
    </div>
    <!--  开放日进度条  -->
    <div v-if="tradeMustKnowProgressInfo.length" class="progress-bar">
      <div
        class="progress-bar-item"
        v-for="(item,index) in tradeMustKnowProgressInfo"
        :key="`progress-${index}`"
        :style="{flex: item.flex}"
      >
        <!--   左右的虚线     -->
        <div class="line" v-if="item.firstTitle" :style="{left: 0}"/>
        <div class="line" v-if="item.lastTitle" :style="{right: 0}"/>
        <!--   文案     -->
        <div class="progress-bar-top">
          <div class="first">
            <div
              v-if="item.firstTitle"
              class="first-title"
              :maxFontZoomScale="1.0"
            >{{ item.firstTitle }}</div>
            <div
              v-if="item.firstSubTitle"
              class="first-sub-title"
            >{{ item.firstSubTitle }}</div>
          </div>
          <div class="last">
            <div
              v-if="item.lastTitle"
              class="last-title"
              :maxFontZoomScale="1.0"
            >{{ item.lastTitle }}</div>
            <div
              v-if="item.lastSubTitle"
              class="last-sub-title"
            >{{ item.lastSubTitle }}</div>
          </div>
        </div>
        <!--   色块 文字     -->
        <div class="block" :style="item.style">
          <div
            :style="item.textStyle"
            class="text"
            :maxFontZoomScale="1.0"
          >{{ item.text }}</div>
        </div>
      </div>
    </div>

    <TabListHeader
    class="tagHead"
    :list="topItems"
    :cur-index="currentIndex"
    @clickTab="changeTag"/>
    <div v-if="tradeRuleInfo.length" class="list">
      <div v-for="(item,index) in tradeRuleInfo" :key="index" class="item">
        <div class="left">{{ item.name }}</div>
        <div style="{color: #666666}" class="right">{{ item.content }}</div>
      </div>
    </div>
    <div class="empty" v-else>
      <div style="color:'#999999'" class="empty-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import TabListHeader from './TabListHeader.vue';

export default {
  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
    mergeData: Object, // 聚合数据
    anchorIndex: Number, // 锚点索引
    productSeatsInfo: Object, // 产品席位信息
  },

  components: {
    TabListHeader,
  },

  data: () => ({
    currentIndex: 0,
    topItems: [
      {
        tabName: '买入规则',
      },
      {
        tabName: '取出规则',
      },
    ],
  }),

  computed: {
    // 交易须知进度条
    tradeMustKnowProgressInfo() {
      return this.mergeData?.tradeMustKnowProgressInfo || [];
    },

    // 交易规则
    tradeRuleInfo() {
      console.log('productSeatsInfo', this.productSeatsInfo);
      const tradeRuleInfo = this.mergeData?.tradeRuleInfo || {};
      const { sellRule } = tradeRuleInfo;
      let buyRule = tradeRuleInfo.buyRule || [];
      if (!isEmpty(this.productSeatsInfo)) {
        const sellState = this.elementData?.sellState;
        const nextOpenDate = this.mergeData?.nextOpenDate;
        const { availableSeat, showSeat } = this.productSeatsInfo;
        // 已售罄 不展示席位
        // 剩余席位为0  不展示
        // 当前日期距离下一预约开始/开放日>3个月，不展示
        // showSeat为false，不展示剩余席位信息
        const now = new Date().getTime();
        const nextOpenDateTimestamp = new Date(nextOpenDate?.replace(/-/g, '/')).getTime();
        const isMoreThan3Month = nextOpenDateTimestamp - now > 3 * 30 * 24 * 60 * 60 * 1000;
        if (
          !(
            [2, 3].includes(parseInt(sellState, 10))
            || availableSeat === 0 || !showSeat || isMoreThan3Month
          )
        ) {
          buyRule = [...buyRule, {
            name: '剩余席位',
            content: Number(availableSeat) >= 100 ? '席位充足' : availableSeat,
          }];
        }
      }
      const { currentIndex } = this;
      return currentIndex === 0 ? buyRule || [] : sellRule || [];
    },

    fundName() {
      const { fundName } = this.elementData;
      return fundName;
    },
  },

  methods: {
    toHighEndTradeRule({ fundCode, fundName }) {
      this.$wxSendTrack('wxgdpzy.jcxx.gdjyxz.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      tool.goDetail(`fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcIndex/index?fundCode=${fundCode}&fundName=${fundName}&index=1`, this.$goFundApp);
    },
    // tab切换
    changeTag(index) {
      if (index !== this.currentIndex) {
        this.currentIndex = index;
      }
    },
  },
};
</script>

<style scoped>
.box {
  margin-top: 24px;
  padding-top: 24px;
  border-radius: 16px;
  background-color: #ffffff;
  padding-bottom: 20px;
}

.top {
  display: flex;
  margin-top: 30px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 14px;
}

.title {
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #000000;
  font-weight: bold;
}

.more {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  text-align: right;
}

.top-right {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.right-arrow {
  /* px2wx:change next */
  width: 32px;
  height: 32px;
  margin-left: 8px;
}

.progress-bar {
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.progress-bar-item {
  justify-content: flex-end;
}

.progress-bar-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.block {
  height: 56px;
  margin-top: 32px;
  justify-content: center;
}
.first {
  margin-left: 8px;
}

.last {
  align-items: flex-end;
  margin-right: 8px;
}

.first-title, .last-title {
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #666666;
  font-weight: 600;
}

.first-sub-title, .last-sub-title {
  margin-top: 15px;
  font-family: DINAlternate-Bold;
  font-size: 24px;
  color: #999999;
  line-height: 24px;
  font-weight: 700;
}

.text {
  line-height: 56px;
  font-size: 28px;
}

.line {
  width: 1px;
  position: absolute;
  top: 0;
  bottom: 0;
  border: 1px dashed #cccccc;
}

.tab {
  background-color: #ffffff;
  width: 360px;
  margin-top: 36px;
}

.item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px 24px;
}
.left {
  width: 150px;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
}
.right {
  flex: 1;
  margin-left: 50px;
  font-family: PingFangSC-Regular;
  font-size: 30px;
  text-align: left;
  line-height: 42px;
  font-weight: 400;
}
.empty {
  height: 200px;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.empty-text {
  font-size: 30px;
}
.tagHead {
  margin-top: 40px;
}

</style>
